import { Dialog, DialogTitle, List, ListItem, ListItemButton, ListItemAvatar, Avatar, ListItemText, CircularProgress, Box } from '@mui/material';
import { blue } from '@mui/material/colors';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';


function ReaderDialog({ open, readers, disabled = false, onClose, onSelectReader }) {
  const handleClose = (value, reason) => {
    if (reason !== "backdropClick") {
      onClose(reason);
    }
  };

  const handleReaderClick = (value) => {
    onSelectReader(value);
  };

  return (
    <Dialog onClose={handleClose} open={open}>
      <DialogTitle>Readers</DialogTitle>
      {
        !readers || readers.length === 0 ?
          <Box sx={{ display: "flex", justifyContent: "center", width: "100%", marginBottom: 4 }}>
            <CircularProgress />
          </Box> :
          <List sx={{ pt: 0 }}>
            {readers.map((reader) => (
              <ListItem disableGutters key={reader.id}>
                <ListItemButton disabled={disabled} onClick={() => handleReaderClick(reader)} >
                  <ListItemAvatar>
                    <Avatar sx={{ bgcolor: blue[100], color: blue[600] }}>
                      <PointOfSaleIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={reader.label} />
                </ListItemButton>
              </ListItem>
            ))}
          </List>
      }
    </Dialog>
  );
}

export default ReaderDialog;
